import { Button, useTheme } from '@mui/material'
import React, { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

interface IShowMoreButton {
    showMore: boolean
    setShowMore: Dispatch<SetStateAction<boolean>>
}

export const ShowMoreButton = ({ showMore, setShowMore }: IShowMoreButton) => {
    const { t: translate } = useTranslation()
    const theme = useTheme()
    const buttonStyle = {
        border: '1px solid white',
        width: '100%',
        height: '30px',
        padding: '8px, 12px, 8px, 12px',
        borderRadius: theme.shape.borderRadius,
        gap: '10px',
        typography: 'text4',
        color: 'white',
        marginTop: '16px',
    }

    return (
        <Button
            data-testid="show-more-button"
            onClick={(event) => {
                event.stopPropagation()
                setShowMore(!showMore)
            }}
            sx={buttonStyle}>
            {showMore ? translate('showLess') : translate('showMore')}
        </Button>
    )
}
